import ProfileSetting from '@/Component/Profile/ProfileSetting'
import TermsAndCondition from '@/Component/Profile/ProfileSetting/TermsAndCondition'


const TermsConditionPage = () => {
    return (
        <ProfileSetting activeTab="terms-conditions">
           <TermsAndCondition/>
        </ProfileSetting>
    )
}

export default TermsConditionPage
